import { formatCurrency, formatNumber } from './number';

export const dkCurrency = (value, locale) => formatCurrency(value, locale);
export const dkNumber = (value, locale) => formatNumber(value, locale);

/**
 * Register filters globally to let import this module without duplicating registration for each filter,
 * for each Vue app.
 */
const registerFilters = (v) => {
    v.filter('dkCurrency', dkCurrency);
    v.filter('dkNumber', dkNumber);
};
export default registerFilters;

export const format = { formatCurrency, formatNumber };
